<section
  class="mbs-wizard_form"
  [formGroup]="stepForm">
  <div class="mbs-wizard_form-content">
    <mbs-form-group
      *ngIf="isConsistencyCheck"
      class="mb-3"
      [attr.data-e2e]="elementSelectors.name.consistencyCheckBlock">
      <mbs-radio
        formControlName="skipLegacy"
        name="skipLegacy"
        [id]="'skip-legacy-radio'"
        [label]="'wizards:skipLegacy' | i18next"
        [subtitle]="'wizards:skipLegacyDescription' | i18next"
        [subtitleOutside]="false"
        [value]="true"></mbs-radio>
      <mbs-radio
        formControlName="skipLegacy"
        name="skipLegacy"
        [id]="'not-skip-legacy-radio'"
        [label]="'wizards:notSkipLegacy' | i18next"
        [subtitleOutside]="false"
        [value]="false"></mbs-radio>
    </mbs-form-group>

    <mbs-form-group
      *ngIf="!isConsistencyCheck && !isProxmox"
      [attr.data-e2e]="elementSelectors.name.useCompression">
      <mbs-checkbox
        formControlName="UseCompression"
        [id]="'enable-compression-checkbox'"
        [label]="'wizards:enable_compression_label' | i18next"></mbs-checkbox>
    </mbs-form-group>

    <mbs-form-group>
      <mbs-checkbox
        formControlName="UseEncryption"
        [descriptionOutside]="false"
        [id]="'enable-encryption-checkbox'"
        [label]="(isConsistencyCheck ? 'wizards:specifyEncryptionPassword' : 'wizards:enable_encryption_label') | i18next"
        (change)="enableEncryptionChangeHandler($event)">
        <ng-container
          *ngIf="isConsistencyCheck"
          appendLabel>
          <span
            class="fa fa-info-circle ml-2 cursor-help text-info"
            container="body"
            tooltipClass="tooltip-lg"
            [attr.data-e2e]="elementSelectors.name.consistencyCheckHelp"
            [ngbTooltip]="'wizards:specifyEncryptionTooltip' | i18next"></span>
        </ng-container>
        <ng-template checkboxDescription>
          <mbs-alert
            *ngIf="needToShowPassRecoveryAlert && !isJumboCOPY && !ability.can('read', 'AgentLocal')"
            [attr.data-e2e]="elementSelectors.name.passRecoveryAlert"
            [icon]="true"
            [type]="mbsPopupType.warning">
            {{ 'shared:pass-recovery.passRecoveryImportanceSubadminWarning' | i18next }}
          </mbs-alert>

          <mbs-form-group>
            <div class="row">
              <div class="col-6">
                <mbs-confirm-password
                  [confirmPlaceholder]="'wizards:confirm_password_label' | i18next"
                  [disabled]="!this.stepForm.get('UseEncryption').value"
                  [errorsTooltipClass]="'tooltip-xl mr-1 mbs-wizard_form-content_tooltip-size'"
                  [errorsTooltipPlacement]="'left'"
                  [errorTooltipTitle]="'shared:password-error-title' | i18next"
                  [fakePassword]="passwordPlaceholder"
                  [hideAsyncValidator]="isConsistencyCheck"
                  [id]="'compressionEncryptionPassword'"
                  [initialPassword]="InitialValue?.EncryptionPassword"
                  [label]="'wizards:password_label' | i18next"
                  [needValidateOnMount]="passwordFormData.password !== passwordPlaceholder"
                  [ngModelOptions]="{ standalone: true }"
                  [placeholder]="'wizards:password_placeholder' | i18next"
                  [showErrorsInTooltip]="stepFocused"
                  [(ngModel)]="passwordFormData"
                  (ngModelChange)="passwordNgModelChangeHandler($event)"></mbs-confirm-password>
              </div>
              <div
                *ngIf="!isConsistencyCheck"
                class="col-6"
                [attr.data-e2e]="elementSelectors.name.encryptionAlgorithm">
                <mbs-form-group>
                  <mbs-select
                    [appendTo]="'.modal-content'"
                    [clearable]="false"
                    [disabled]="!stepForm.get('UseEncryption').value"
                    [id]="'EncryptionAlgorithm'"
                    [items]="encryptionAlgorithmDisplays"
                    [label]="'wizards:algorithm_label' | i18next"
                    [ngModelOptions]="{ standalone: true }"
                    [searchable]="false"
                    [(ngModel)]="selectedEncryptionAlgorithmDisplays"
                    (close)="encryptionAlgorithmCloseHandler()"></mbs-select>
                </mbs-form-group>
              </div>
            </div>
          </mbs-form-group>

          <mbs-form-group
            *ngIf="!isUnix && showUseFileNameEncryption"
            [attr.data-e2e]="elementSelectors.name.useFileNameEncryption">
            <mbs-checkbox
              formControlName="UseFileNameEncryption"
              [id]="elementSelectors.id.UseFileNameEncryption"
              [label]="'wizards:encryption_filenames_label' | i18next"
              (change)="useFileNameEncryptionChangeHandler($event)">
              <ng-container appendLabel>
                <mbs-wizards-legacy-property-tooltip
                  *ngIf="!this.isNBF && stepForm.get('UseFileNameEncryption').disabled"
                  [attr.data-e2e]="elementSelectors.name.useFileNameEncryptionTooltip"></mbs-wizards-legacy-property-tooltip>
              </ng-container>
            </mbs-checkbox>
          </mbs-form-group>
          <mbs-form-group
            *ngIf="isNBF || (isUnix && correctlyVersionAgent)"
            [attr.data-e2e]="elementSelectors.name.hintAndAlert">
            <mbs-input
              formControlName="hint"
              [label]="'wizards:hint_label' | i18next"
              [validationWhitespace]="true"></mbs-input>
            <mbs-alert
              *ngIf="!isNBF && isUnix && isRDMode"
              class="mt-3"
              [attr.data-e2e]="elementSelectors.name.hintAlert"
              [icon]="true"
              [type]="mbsPopupType.info">
              {{ 'wizards:agent_version_hint_alert_text' | i18next }}
            </mbs-alert>
          </mbs-form-group>
        </ng-template>
      </mbs-checkbox>
    </mbs-form-group>

    <mbs-alert
      *ngIf="needShowAlert"
      [attr.data-e2e]="elementSelectors.name.compressionEncryptionAlert"
      [icon]="true"
      [type]="mbsPopupType.warning">
      {{ 'wizards:compression_encryption_alert_text' | i18next }}
    </mbs-alert>
  </div>
</section>
